import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import EmptyStateWithSteps from "../../../advanced-search/components/shared/EmptyStateWithSteps/EmptyStateWithSteps";
import {
    StyledButtonContainer,
    StyledList,
} from "../../../advanced-search/components/shared/EmptyStateWithSteps/styles";

export const StyledImage = styled.img`
    display: block;
    height: auto;
    width: 132px;
`;

export const StyledProfilesEmptyState = styled(EmptyStateWithSteps)`
    background-color: ${colorsPalettes.carbon["0"]};
    position: relative;

    &::before {
        background-color: ${colorsPalettes.blue["300"]};
        content: "";
        display: block;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 2px;
        z-index: 1;
    }

    ${StyledList} {
        margin: 8px 0 0;
    }

    ${StyledButtonContainer} {
        padding-bottom: 6px;
        padding-top: 24px;
    }
`;
